<template>
  <UiDropdownInput
    class="sort-dropdown"
    :label="{
      text: $t('products.sort'),
      position: LabelPosition.IN,
    }"
    :dropdown-list="sortByOptions"
    @update:selected-option="handleSelectedOption"
  />
</template>

<script setup lang="ts">
import type {
  DropdownOption,
  SortProps,
} from '~/types/components/product-listing/sort/sort.types'
import UiDropdownInput, { LabelPosition } from '@sephora-asia/ui-dropdown-input'

const emit = defineEmits<{
  (event: 'update:selectedOption', value: string): void
}>()

const props = defineProps<SortProps>()

const { trackEvent } = useGtmTrack()

const sortByOptions = computed((): DropdownOption[] => {
  const defaultOptionValue = 'sales'
  return props.sortOptions.map((option: DropdownOption) => ({
    ...option,
    isSelected: option.value === defaultOptionValue ? false : option.isSelected,
  }))
})

function handleSelectedOption(value: string) {
  emit('update:selectedOption', value)
  onTrackingEvent(value)
}

function onTrackingEvent(value: string) {
  trackEvent({
    event: 'click',
    params: {
      event_category: 'Filters',
      event_action: 'Sort By',
      event_label: value,
    },
  })
}
</script>

<style lang="scss" scoped>
.sort-dropdown {
  flex-grow: 1;
  display: flex;
  justify-content: center;

  :deep(.select) {
    @extend .headline-m;
    border: none;
    width: 100%;
    text-align: center;
    // fix text color and alignment for Safari
    text-align-last: center;
    color: var(--color-base-black);
  }
}
</style>
